import { render, staticRenderFns } from "./OpportunitiesList.vue?vue&type=template&id=dab67cc4&scoped=true"
import script from "./OpportunitiesList.vue?vue&type=script&lang=js"
export * from "./OpportunitiesList.vue?vue&type=script&lang=js"
import style0 from "./OpportunitiesList.vue?vue&type=style&index=0&id=dab67cc4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dab67cc4",
  null
  
)

export default component.exports